import React, { Component } from 'react'; 
import { withstyles, Paper, Typography, Button, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, withStyles, TextField, MenuItem, Divider, Grid, Dialog, DialogActions, DialogContent, DialogContentText, 
    DialogTitle, Slide, CircularProgress, Table, TableBody, TableCell,TableHead, TableRow, TablePagination, Checkbox, FormGroup, Switch } from '@material-ui/core';
import { } from '@material-ui/icons';
import creds from '../../config/firebaseConfig';
import db from '../../config/firestoreConfig';

const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        position: 'relative',
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        margin: 'auto',
        width: '75%',
        overflowX: 'auto'
    },
    container: {
        display: 'block',
        flexWrap: 'wrap',
        width: '100%',
        padding: 10,
        margin: 'auto',
        alignItems: 'center',
        alignContent: 'center',
        overflowX: 'auto'
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 300,
        padding: 5,
    },
    table: {
        minWidth: 700,
        maxHeight: '60vh'
    },
    tabBar: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
})

let id = 0;

class ViewPerformance extends Component{
    constructor(props){
        super(props)
        this.state = {
            students: [],
            groups: [],
            tasks: [],
            studentProcessed: [],
            groupsProcessed: [],
            checkedList : [],
            page: 0,
            rowsPerPage: 10,
            searchPhrase: '',
            selected: {
                student: {data: {data: false}},
                group: { data: {data: false}},
            },
            dataForTable: {
                students: [],
                groups: []
            }
        }
    }

     async componentDidMount(){
        var students = await this.fetchStudents()
        var tasks = await this.fetchTasks()
        var groups = await this.fetchGroups()
        console.log(students, tasks, groups)
        this.processStudents(students, tasks)
        this.processGroups(groups, tasks)

        // db.collection('Users').where('accountType', '==', 'Student').get()
        // .then( snapshot => { 
        //     snapshot.forEach(doc => { 
        //         students.push(doc.data())
        //     })
        // })

       
        

        // db.collection('WorkGroups').get()
        // .then( snapshot => { 
        //     snapshot.forEach(doc => { 
        //         groups.push(doc.data())
        //     })
        // })

        // db.collection('AssignedTasks').get()
        // .then( snapshot => { 
        //     snapshot.forEach(doc => { 
        //         tasks.push(doc.data())
        //     })
        // })

        // console.log(students, groups, tasks)
        // this.setState({
        //     ...this.state,
        //     students: this.fetchStudents(),
        //     groups: groups,
        //     tasks: this.fetchTasks()
        // }, this.processStudents(students, tasks))  
    }

    fetchStudents = async () => {
        var students = [] 
        var ref = db.collection('Users').where('accountType', '==', 'Student')
        var snapshot = await ref.get()
        snapshot.forEach(doc => { 
            students.push(doc.data())
        })
       this.setState({
           ...this.state,
           students : students
       })
       return students
    }

    fetchGroups = async () => {
        var groups = [] 
        var ref = db.collection('WorkGroups')
        var snapshot = await ref.get()
        snapshot.forEach(doc => { 
            groups.push(doc.data())
        })
       this.setState({
           ...this.state,
           groups : groups
       })
       return groups
    }



    fetchTasks = async () => { 
        var tasks = []
        var ref = db.collection('AssignedTasks')
        var snapshot = await ref.get()
        snapshot.forEach(doc => { 
            tasks.push({title: doc.id, data: doc.data()})
        })
        this.setState({
            ...this.state,
            tasks : tasks
        })
        return tasks
    }

    //-----------------------------------POST FETCH PROCCESSING FUNCTIONS---------------------------//
    processStudents = (students, tasks) => { 
        var matchedRows = []
        var students2 = this.state.students
        // console.log('STARTED', students, students2, students.length ) //DEBUG
        students.forEach(student => { 
            // console.log(student)
            var holdingArr = []
            tasks.forEach( task => { 
                task.data.AssignedTo.forEach(s => { 
                    if (s.Student == student.UID && s.CompletionDate != 'N/A') {
                        holdingArr.push({title: task.title, data: s})
                    }
                }) 
            })
            matchedRows.push({uid: student.UID, tasks: holdingArr, name: student.displayName})
            // console.log(holdingArr)
        })
        // console.log('MATCHED ROWS', matchedRows)
        this.matchedRows(matchedRows)
    }

    processGroups = (groups, tasks) => { 
        var matchedRows = []
        console.log('STARTED', groups, groups.length ) //DEBUG
        groups.forEach(group => { 
            var holdingArr = []
            tasks.forEach( task => { 
                var count = 0
                group.Members.forEach(m => {
                    task.data.AssignedTo.forEach(s => { 
                        if (m.uid == s.Student){
                            count = count + 1
                        }
                    })
                })
                if (count == group.Members.length) { 
                    holdingArr.push({title: task.title, data: task.data.AssignedTo})
                }
            })
            matchedRows.push({gName: group.name, members: group.Members, tasks: holdingArr})
        })
        console.log('MATHCED', matchedRows)
        this.matchedRowsGroups(matchedRows)
    }

 

    matchedRows = arr => { 
        var output = []
        arr.forEach(row => { 
            var mostRecent = [] 
            if (row.tasks.length > 1) {
                row.tasks.forEach(task => { 
                    if (mostRecent.length < 1) {
                        mostRecent.push({time: new Date (task.data.CompletionDate).valueOf(), data: task, student: row.name})
                    } else if (new Date (task.data.CompletionDate).valueOf() > mostRecent[0].time){
                        mostRecent[0] = {time: new Date (task.data.CompletionDate).valueOf(), data: task, student: row.name}
                    }
                })

            } else {
                if (row.tasks.length == 0){
                    mostRecent.push({time: 'N/A', data: 'N/A', student: row.name})
                } else {
                    // console.log(row) //DEBUG
                    mostRecent.push({time: new Date (row.tasks[0].data.CompletionDate).valueOf(), data: row.tasks[0], student: row.name})
                }
            }
            output.push(mostRecent[0])
        })
        // console.log('OUTPUT', output)
        this.setState({
            ...this.state,
            dataForTable: { 
                ...this.state.dataForTable,
                students: output,
            }
        })
    }

    matchedRowsGroups = arr => {
        var output = []
        arr.forEach(row => { 
            var mostRecent = []
            if (row.tasks.length > 1) {
                row.tasks.forEach( task => {
                    var hold = 0
                    if (mostRecent.length < 1){
                        task.data.forEach(record => { 
                            if (record.CompletionDate != 'N/A' && new Date(record.CompletionDate).valueOf() > hold) {
                                 hold = new Date(record.CompletionDate).valueOf()
                            } 
                        })
                        mostRecent.push({gName: row.gName, time: hold, data: task, members: row.members})
                    } else {
                        task.data.forEach(record => { 
                            if (record.CompletionDate != 'N/A' && new Date(record.CompletionDate).valueOf() > hold) {
                                 hold = new Date(record.CompletionDate).valueOf()
                            } 
                        })
                        if (hold > mostRecent[0].time){
                            mostRecent[0] = ({gName: row.gName, time: hold, data: task, members: row.members})
                        }
                    }
                })
            } else { 
                if (row.tasks.length == 0){
                    mostRecent.push({gName: row.gName, time: 'N/A', data: 'N/A', members: row.members})
                } else {
                    var hold = 0
                    row.tasks[0].data.forEach(record => { 
                        if (record.CompletionDate != 'N/A' && new Date(record.CompletionDate).valueOf() > hold) {
                            hold = new Date(record.CompletionDate).valueOf()
                        }
                    })
                    mostRecent.push({gName: row.gName, time: hold, data: row.tasks[0], members: row.members})
                }
            }
            output.push(mostRecent[0])
        })
        console.log('OUTPUT2', output)
        this.setState({
            ...this.state,
            dataForTable: { 
                ...this.state.dataForTable,
                groups: output
            }
        })
    }

    


    //----------------------------------TABLE FUNCTIONS-------------------------------//

     //CREATE DATA FOR TABLE
    createData(name, uid, taskName, result, punctuality) {
        id += 1;
        return {id, name, uid, taskName, result, punctuality}; 
    }

    

    //ITEMS FOR THE TABLE   
    rows = (arr) => {
        var output = []
        console.log(arr);
        arr.map(record => {
            if (record.data != 'N/A') {
                output.push(
                    this.createData(record.data.data.displayName, record.data.data.Student, record.data.title, record.data.data.Score, this.wasLate(record.data.data.punctuality))
                )
            } else {
                output.push(
                    this.createData(record.student, this.displayName(record.student),  'N/A', 0, 'N/A')
                )
            }

            
        })
        return output
    }

    createDataGroups(name, members, taskName, result, punctuality) {
        id += 1;
        return {id, name, members, taskName, result, punctuality}; 
    }

    rowsGroups = (arr) => {
        var output = []
        console.log(arr);
        arr.map(record => {
            if (record.data != 'N/A') {
                output.push(
                    this.createDataGroups(record.gName, record.members, record.data.title, this.avgScore(this.membersOnly(record.data.data, record.members)), this.avgPunctuality(this.membersOnly(record.data.data, record.members)))
                )
            } else {
                output.push(
                    this.createDataGroups(record.gName, record.members,  'N/A', 0, 'N/A')
                )
            }

            
        })
        return output
    }

    membersOnly = (arr, names) => {
        var output = []
        arr.forEach( student => { 
            names.forEach(member => { 
                if (student.Student == member.uid){
                    output.push(student)
                }
            })
            if (output.length == names.length){
                return
            }
        })
        return output
    }
    
    avgScore = arr => { 
        var runningTotal = 0
        arr.forEach(s => {
            runningTotal = runningTotal + s.Score
        })
        runningTotal = Math.round(runningTotal/arr.length)
        return runningTotal
    }

    avgPunctuality = arr => { 
        var runningTotal = 0
        var completed = 0
        arr.forEach(s => { 
            if (s.CompletionDate != 'N/A'){
                completed = completed + 1
                runningTotal = runningTotal + s.punctuality
            }
        })
        if (runningTotal != 0){
            runningTotal = Math.round(runningTotal/completed)
        }
        return runningTotal
    }

    displayName = name => { 
        var students = this.state.students
        console.log(students, name)
        var output
        students.forEach( student => { 
            if (student.displayName == name){
                return output = student.UID
            }
        })
        return output
    }
    wasLate = value => { 
        if (value >! 0) {
            return value
        } else { 
            return 'Late'
        }
    }

    makeTableData = () => {
        return this.searchArr(this.rows(this.state.dataForTable.students), this.state.searchPhrase)
        
    }

    makeTableDataGroups = () => {
        return this.searchArrGroups(this.rowsGroups(this.state.dataForTable.groups), this.state.searchPhrase)
        
    }

    searchArr = (arr, searchTerm ) => {
        // console.log(searchTerm)
        // console.log('SEARCH', arr)
        searchTerm = searchTerm.toLowerCase()
        var output = [];
        arr.forEach(e => {
            if (e.name == undefined){
                e.name = 'N/A'
            }
            if (e.name.toLowerCase().search(searchTerm) != -1) {
                output.push(e)
            }
        })
        return output
    }

    searchArrGroups = (arr, searchTerm ) => {
        if (searchTerm.includes(', ')){
            searchTerm = searchTerm.toLowerCase()
            var searchArr = searchTerm.split(', ')
            var count = 0;
            var holdingArr = [];
            var output = [];
            // console.log('SEARCH ARR', searchArr)
            arr.forEach( list => {
                var members = [];
                count = 0;
                if (list.members.length > 1){
                    list.members.forEach(n => { 
                        members.push(n.Name.toLowerCase())
                    })
                    // console.log('MEMEBRS', members)
                    searchArr.forEach( name  => {
                        // console.log('wtf is going on', members, name, members.includes(name))
                        if (members.indexOf(name) != -1){
                            count = count + 1
                        }
                    })
                    // console.log('COUNT', count, searchArr.length, searchArr, members)
                    if (count == searchArr.length && output.indexOf(list) == -1){
                        return output.push(list)
                    }
                }
            })
            return output
        } else if (searchTerm.includes(' ')) {
            searchTerm = searchTerm.toLowerCase()
            var searchArr = searchTerm.split(' ')
            var count = 0;
            var holdingArr = [];
            var output = [];
            // console.log('SEARCH ARR', searchArr)
            arr.forEach( list => {
                var members = [];
                count = 0;
                if (list.members.length > 1){
                    list.members.forEach(n => { 
                        members.push(n.Name.toLowerCase())
                    })
                    // console.log('MEMEBRS', members)
                    searchArr.forEach( name  => {
                        // console.log('wtf is going on', members, name, members.includes(name))
                        if (members.indexOf(name) != -1){
                            count = count + 1
                        }
                    })
                    // console.log('COUNT', count, searchArr.length, searchArr, members)
                    if (count == searchArr.length && output.indexOf(list == -1)){
                        return output.push(list)
                    }
                }
            })
            return output
        } else {
            searchTerm = searchTerm.toLowerCase()
            var output = [];
            arr.forEach(e => {
                // console.log('£', e)
                e.members.forEach( member => {
                    if (member.Name.toLowerCase().search(searchTerm) != -1 && !output.includes(e)) {
                        return output.push(e)
                    }
                })
            })
            return output
        }
       
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };
    
    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    groupPerQ = arr => { 
        console.log(arr, this.state.selected.group, this.state.checkedList)
        var output = [] 
        var gotItWrong = []
        var selectedGroup = this.state.selected.group 
        var gMembers = []
        selectedGroup.members.forEach(m => {
            gMembers.push(m.uid)
        })
        arr.forEach(s => { 
            if (s.perQuestion && gMembers.indexOf(s.Student) != -1) {
                s.perQuestion.forEach(q => { 
                    if (q.result == false){
                        var index = -1
                        output.forEach(row => {
                            if (row.id == q.id){
                                index = output.indexOf(row)
                            }
                        })
                        if (index != -1) {
                            gotItWrong[index].push(s.displayName)
                        } else {
                            output.push(q)
                            gotItWrong.push([s.displayName])
                        }

                    }
                    
                })
            }
        })
        console.log(output, gotItWrong)
        return ({perQ: output, gotItWrong: gotItWrong})
    }

    //----------------------------------CHANGE HANDLERS-------------------------------//

     checked = () => event => {
        this.setDialogDataStudents(event.target.value)
        console.log(event.target.value)
        var arr = [];
        const index = arr.indexOf(event.target.value)
        console.log(index)
        if  (index != -1) {
            arr.splice(index, 1)
        } else {
            arr.push(event.target.value)
        }
        console.log(arr)
        this.setState({
            checkedList: arr
        })
        console.log(this.state.checkedList)
    }


    checkedGroup = row => event => {  
        
        console.log(row, event.target.value, this.state.groupsProcessed)
        //call the set dialog function here
        const groups = this.state.groupsProcessed
        var id = event.target.value
        var membersArr = []
        row.members.forEach(m => {
            membersArr.push(m.Name)
        })
        console.log('MEMBERS', membersArr)
        this.setState({
            checkedList: [event.target.value] 
        })
        this.setDialogDataGroups(row)
    }


    handleChange = name => event => {
        this.setState({
            ...this.state,
            [name]: event.target.value
        })
    }

    setDialogDataStudents = name => { 
        var students = this.state.dataForTable.students
        var thisRow
        console.log('HERE', students, name)
        students.forEach(student => { 
            if (student.student == name){
                return thisRow = student
            }
        })
        this.setState({
            ...this.state,
            selected : {
                student : thisRow
            },
            studentDialog: true
        })
        console.log('STATE', this.state)   
    }

    setDialogDataGroups = names => { 
        var groups = this.state.dataForTable.groups
        var thisRow
        console.log('NAMES', names, this.state.checkedList)
        console.log('HERE', groups, names)
        groups.forEach(group => { 
            if (group.members == names.members){
                console.log('MATCH')
                return thisRow = group
            }
        })
        this.setState({
            ...this.state,
            selected : {
                student : this.state.selected.student,
                group : thisRow
            },
            groupDialog: true
        })

    }

    objArrToArr = arr => {
        var output = []
        arr.forEach(obj => { 

        })
    }

    handleClose = () => {
        this.setState({ 
            studentDialog: false,
            groupDialog: false,
            checkedList: [],
            selected: {
                student: this.state.selected.student,
                group: {
                    data: false
                }
            }
        });
    };

    handleSwitch = () => { 
        this.setState({
            ...this.state,
            switched: !this.state.switched
        })
    }
    //--------------------------------------------------------------------------------//


    render(){
        const { classes } = this.props;
        return (
        <Grid container direction= 'column' justify='center'>
            <Grid item xs={12}>
            <Paper className={classes.root}>
                
                               
                {this.state.dataForTable ? 
                    <div className={classes.container}>
                        <div sytle={{width: '100%'}}>
                            {!this.state.switched ? 
                                <Typography variant='headline'>
                                    Most Recent Tasks Per Student
                                    <div style={{ marginLeft: 10, marginBottom: 10, float: 'right'}}>
                                    <FormGroup row>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={this.state.switched}
                                                    onChange={()=> this.handleSwitch()}
                                                    color='primary'
                                                />
                                            }
                                            label={'View Groups'}
                                        />
                                    </FormGroup>
                                    <br/>
                                    </div>
                                </Typography>
                            :
                                <Typography variant='headline'>
                                    Most Recent Tasks Per Group
                                    <div style={{ marginLeft: 10, marginBottom: 10, float: 'right'}}>
                                    <FormGroup row>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={this.state.switched}
                                                    onChange={()=> this.handleSwitch()}
                                                    color='primary'
                                                />
                                            }
                                            label={'View Groups'}
                                        />
                                    </FormGroup>
                                    <br/>
                                    </div>
                                </Typography>
                            }
                            
                        </div>
                        <br/> 
                        <Divider/>
                        <br/>
                        <TextField className={classes.TextField}
                            onChange={this.handleChange('searchPhrase')}
                            value={this.state.searchPhrase}
                            helperText='Search via display name(s)'
                        />
                        <br/>
                        <br/>
                        <Paper style={{overflowX: 'auto'}} >
                            {!this.state.switched ? 
                                <div>
                                    <Table className={classes.table}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell><Checkbox disabled={true}/></TableCell>
                                                <TableCell>Student Name</TableCell>
                                                <TableCell>UID</TableCell>
                                                <TableCell>Most recent task</TableCell>
                                                <TableCell>Result</TableCell>
                                                <TableCell>Days early</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.makeTableData()
                                                .slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
                                                .map(row => {
                                                return (
                                                    
                                                    <TableRow 
                                                        key={row.id}
                                                        hover
                                                        tabIndex={-1}>
                                                        <TableCell><Checkbox  value={row.name} onChange={this.checked()} checked={(this.state.checkedList.indexOf(row.name) != -1)}/></TableCell>
                                                        <TableCell component="th" scope="row">
                                                        {row.name}
                                                        </TableCell>
                                                        <TableCell>{row.uid}</TableCell>
                                                        <TableCell>{row.taskName}</TableCell>
                                                        <TableCell>{row.result}</TableCell>
                                                        <TableCell>{row.punctuality}</TableCell>
                                                    </TableRow>
                                                    
                                                )
                                            })}
                                        </TableBody>   
                                    </Table>
                                    <TablePagination
                                        component='div'
                                        count={this.makeTableData().length}
                                        rowsPerPage={this.state.rowsPerPage}
                                        page={this.state.page}
                                        backIconButtonProps={{
                                            'aria-label': 'Previous Page',
                                        }}
                                        nextIconButtonProps={{
                                            'aria-label': 'Next Page',
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </div>
                            :
                                <div>
                                    <Table className={classes.table}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell><Checkbox disabled={true}/></TableCell>
                                                <TableCell>Group Name</TableCell>
                                                <TableCell>Members</TableCell>
                                                <TableCell>Most recent task</TableCell>
                                                <TableCell>Avg Result</TableCell>
                                                <TableCell>Avg Days early</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.makeTableDataGroups()
                                                .slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
                                                .map(row => {
                                                return (
                                                    
                                                    <TableRow 
                                                        key={row.id}
                                                        hover
                                                        tabIndex={-1}>
                                                        <TableCell><Checkbox  value={row.id} onChange={this.checkedGroup(row)} checked={this.state.selected.group.members == row.members}/></TableCell>
                                                        <TableCell component="th" scope="row">
                                                        {row.name}
                                                        </TableCell>
                                                        <TableCell>
                                                            {row.members.map(m => {
                                                                m = m.Name + ', '
                                                                return m
                                                            })}
                                                        </TableCell>
                                                        <TableCell>{row.taskName}</TableCell>
                                                        <TableCell>{row.result}</TableCell>
                                                        <TableCell>{row.punctuality}</TableCell>
                                                    </TableRow>
                                                    
                                                )
                                            })}
                                        </TableBody>   
                                    </Table>
                                    <TablePagination
                                        component='div'
                                        count={this.makeTableDataGroups().length}
                                        rowsPerPage={this.state.rowsPerPage}
                                        page={this.state.page}
                                        backIconButtonProps={{
                                            'aria-label': 'Previous Page',
                                        }}
                                        nextIconButtonProps={{
                                            'aria-label': 'Next Page',
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </div>
                            }
                        </Paper>
                    </div>
                :
                    <div/>
                }
                 <Dialog
                        open={this.state.studentDialog}
                        onClose={this.handleClose}
                        aria-labelledby="form-dialog-title"
                    >
                    <DialogTitle id="form-dialog-title">{this.state.selected.student ? this.state.selected.student.student : <p/>} Recent Performance </DialogTitle>
                    <Divider/>
                    <DialogContent>
                        <div>
                    {this.state.selected.student && this.state.selected.student.data && this.state.selected.student.data.data != false && this.state.selected.student.data != 'N/A' ? 
                    <div>
                    <span style={{width: '100%'}} >
                        <br/>
                        
                        <Typography variant='subheading' >
                            {'Task: ' + this.state.selected.student.data.title}
                            <br/>
                            {'Result: ' + this.state.selected.student.data.data.Score + '%'}
                        </Typography>
                    </span>
                    <br/>
                    <Divider/>
                    <Typography variant='body1'>
                        {'These questions need revising'}
                        <Divider/>
                    </Typography>
                    <br/>
                    
                            {this.state.selected.student.data.data.perQuestion.map(question => { 
                                if (!question.result) {
                                    return (
                                        <div>
                                            <Typography variant='subheading'>
                                                {question.id + ': ' + question.question + ' ' }
                                                {'- ' + question.weight + ' marks'}
                                            </Typography>
                                            {question.file ?
                                                <Typography variant='body2'>
                                                    {'File: ' + question.file}
                                                </Typography>
                                            :
                                                <div/>
                                            }
                                            <Typography variant='caption'>
                                                {'Areas: ' + question.tags.map(tag => { 
                                                    return tag + ' '
                                                })}
                                            </Typography>
                                            <br/>
                                        </div>
                                    )
                                } 
                            })}
                            </div>
                        :
                            <Typography variant='subheading'>
                                No recent data
                            </Typography>
                        }
                        </div>
                    
                    </DialogContent>
                    <DialogActions>
                    <Button variant='raised' onClick={() => this.handleClose()}>
                            Close
                    </Button>
                    <Button variant='raised' onClick={() => console.log('GO TO TASK', this.state.seleccted.student.data)}>
                            Go to task
                    </Button>
                    </DialogActions>
                </Dialog>

                 <Dialog
                        open={this.state.groupDialog}
                        onClose={this.handleClose}
                        aria-labelledby="form-dialog-title"
                    >
                    {console.log(this.state.selected)}
                    <DialogTitle id="form-dialog-title">{} Recent Performance </DialogTitle>
                    <Divider/>
                    <DialogContent>
                        <div>
                    {this.state.selected.group && this.state.selected.group.data != 'N/A' && this.state.groupDialog ? 
                    <div>
                    <span style={{width: '100%'}} >
                        <br/>
                        
                        <Typography variant='subheading' >
                            {'Task: ' + this.state.selected.group.data.title}
                            <br/>
                            {/* {'Avg Result: ' + this.state.checkedList[0].result + '%'} */}
                        </Typography>
                    </span>
                    <br/>
                    <Divider/>
                    <Typography variant='body1'>
                        {'These questions need revising'}
                        <Divider/>
                    </Typography>
                    <br/>
                    
                            {this.groupPerQ(this.state.selected.group.data.data).perQ.map(question => { 
                                    return (
                                        <div>
                                            <Typography variant='subheading'>
                                                {question.id + ': ' + question.question + ' ' }
                                                {'- ' + question.weight + ' marks'}
                                            </Typography>
                                            {question.file ?
                                                <Typography variant='body2'>
                                                    {'File: ' + question.file}
                                                </Typography>
                                            :
                                                <div/>
                                            }
                                            <Typography variant='caption'>
                                                {'Areas: ' + question.tags.map(tag => { 
                                                    return tag + ' '
                                                })}
                                            </Typography>
                                            <Typography variant='caption'>
                                                {'Members: ' + this.groupPerQ(this.state.selected.group.data.data).gotItWrong[this.groupPerQ(this.state.selected.group.data.data).perQ.indexOf(question)].map(m => { 
                                                    return m + ', '
                                                })}
                                            </Typography>
                                            <br/>
                                        </div>
                                    ) 
                            })}
                            </div>
                        :
                            <Typography variant='subheading'>
                                No recent data
                            </Typography>
                        }
                        </div>
                    
                    </DialogContent>
                    <DialogActions>
                    <Button variant='raised' onClick={() => this.handleClose()}>
                            Close
                    </Button>
                    <Button variant='raised' onClick={() => console.log('GO TO TASK', this.state.selected.group.data)}>
                            Go to task
                    </Button>
                    </DialogActions>
                </Dialog>
            </Paper>
            </Grid>
        </Grid>
        )
    }
}
export default withStyles(styles)(ViewPerformance);


// WEBPACK FOOTER //
// ./src/pages/View/performance.jsx